// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`VendorOnboarding FORM_SCREEN renders the component 1`] = `
.c0 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.c2 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.c1 {
  background-color: #e3e8f1;
  margin: -15px -15px 60px -20px;
  min-height: calc(100vh - 130px);
  padding: 50px 0 20px;
}

<div>
  <div
    class="c0 c1"
  >
    <div
      class="c2"
    >
      {Form}
    </div>
  </div>
</div>
`;

exports[`VendorOnboarding SUCCESS_SCREEN renders the component 1`] = `
.c0 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.c2 {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.c1 {
  background-color: #e3e8f1;
  margin: -15px -15px 60px -20px;
  min-height: calc(100vh - 130px);
  padding: 50px 0 20px;
}

<div>
  <div
    class="c0 c1"
  >
    <div
      class="c2"
    >
      {Success}
    </div>
  </div>
</div>
`;
